<template>
  <div class="page aktionaersbrief">
    <progress max="100" value="0"></progress>
    <section id="sec_02" class="section_01 section section__vh">
      <div class="container">
        <div class="content content__medium">
          <div class="item content-image">
            <div class="panel panel--shadow">
              <img src="../assets/images/vorstand.jpg" alt="" />
            </div>
          </div>
          <div class="item content-text">
            <div class="content-wrapper">
              <h2 class="cursive">
                Geschätzte Aktionärinnen und Aktionäre,<br />
                liebe Mitarbeiterinnen und Mitarbeiter,<br />
                sehr geehrte Damen und Herren,
              </h2>
              <p>
                das zurückliegende Jahr 2022 war für die ODR und ihre
                100-prozentige Netztochter Netze ODR sowie für die gesamte
                Energiewirtschaft ein anstrengendes und herausforderndes Jahr.
                Besonders hervorzuheben ist hier der seit über einem Jahr
                andauernde russische Angriffskrieg gegen die Ukraine, welcher
                eine historische Zäsur darstellt und uns fassungslos macht.
                Infolge des Ukrainekrieges kam es unter anderem zu
                Preisturbulenzen an den Energiemärkten, einer stark gestiegenen
                Inflation sowie weltweiten Lieferengpässen und – nicht zu
                vergessen – zu einer kritischen Lage in der Gasversorgung über
                den Winter. Der Krieg in der Ukraine veränderte die
                Energiewirtschaft fundamental und brachte eine nie dagewesene
                Herausforderung und große Unsicherheit mit sich. Die Ära
                verlässlicher und bezahlbarer Energielieferungen aus Russland
                fand ein abruptes Ende. Wir haben erkannt, dass die Abhängigkeit
                von russischem Gas und russischer Kohle schnell und nachhaltig
                zu beseitigen ist. Auch mussten wir lernen, mit den seit Anfang
                2021 stetig gestiegenen Preisen von Strom und Gas an den
                Großhandelsmärkten umzugehen. Die Preise für Strom notierten in
                2022 zeitweise bis zu sieben Mal höher als im Vorjahr, bei Gas
                sogar um den Faktor 20. Diese Marktveränderungen in Verbindung
                mit der hohen Inflation sind für die Industrie sowie auch für
                die Bürgerinnen und Bürger eine enorme Belastung. Zwar
                stabilisierten sich die Märkte und die Preise gehen wieder
                zurück, allerdings haben wir das Niveau von Anfang 2021 längst
                nicht erreicht.
              </p>
              <p>
                Diese Krise sehen wir jedoch als Chance. Die ODR und Netze ODR
                als regional verankerte Unternehmen im östlichen
                Baden-Württemberg und angrenzenden Bayern sind der Wirtschaft
                und den Kommunen und Bürgern der Region in dieser Situation
                verpflichtet. Um unseren Energiebedarf zu decken und die
                Klimaziele zu erreichen, muss die Energiewende deutlich
                beschleunigt werden. Wir tragen unseren Teil zu diesem Wandel
                bei, indem wir konsequent in die Energiewende investieren.
              </p>
              <p>
                Unsere Ausrichtung bis 2030 basiert auf drei Säulen des
                strategischen Wachstums: Zum einen auf dem beschleunigten Ausbau
                der systemrelevanten Infrastruktur. Insbesondere die
                Verteilnetze für Strom und Breitband sowie die netznahen
                Dienstleistungen sind hier von Bedeutung. Die
                gesellschaftsrechtliche Umwandlung zur großen Netzgesellschaft
                „Netze ODR GmbH“ in 2021 verschafft uns dabei die
                wirtschaftliche Kraft.
              </p>
            </div>
            <div class="content-wrapper">
              <p>
                Zum anderen die Säule kundennahe Energielösungen. Neben dem
                Vertrieb von Strom und Gas sind hier die E-Mobilität,
                Photovoltaik sowie Wärme- und Energielösungen von besonderer
                Bedeutung.
              </p>
              <p>
                Die erneuerbare Erzeugungsinfrastruktur repräsentiert die dritte
                Säule unseres Wachstums. Im Segment Photovoltaik-Flächenanlagen
                und Windkraftanlagen werden wir zunehmende Aktivitäten entfalten
                und unsere Investitionen in die erneuerbaren Energien erkennbar
                ausbauen.
              </p>
              <p>
                Diese Entwicklung wird in den nächsten Jahren durch einen
                deutlichen Personalzuwachs sowie durch die zunehmende
                Digitalisierung und den Ausbau unserer unternehmenseigenen
                Infrastruktur getragen. Basis bleibt dabei weiterhin die
                erfolgreiche Sicherung der Konzessionen in der Netze ODR.
              </p>
              <p>
                Das Fundament, um alle vor uns liegenden Herausforderungen
                meistern zu können, ist ein starkes Team – und das haben wir.
                Unsere rund 650 Mitarbeiter der ODR und der Netze ODR haben im
                vergangenen Jahr hervorragendes geleistet. Trotz der schwierigen
                Rahmenbedingungen wurden die gesteckten Ziele im Netzgeschäft
                und Vertrieb erfolgreich erreicht. Das Geschäft der
                Elektromobilität und das Breitbandgeschäft zeigen zunehmend eine
                positive Entwicklung. Das erfolgreiche Engagement unserer
                Mitarbeiter spiegelt sich auch in der Tatsache wider, dass im
                Netzgebiet der Netze ODR zwischenzeitlich rund 36.000
                EEG-Anlagen von Bürgerinnen und Bürgern sowie Unternehmen an das
                Netz angeschlossen sind und unsere Region dadurch ca. 74 Prozent
                des Strombedarfs selbst erzeugt. Auch bei neuen
                Herausforderungen, wie dem Schutz unserer Unternehmen gegen die
                stetig wachsende Cyberkriminalität, haben unsere Mitarbeiter
                intelligente Lösungen erarbeitet.
              </p>
              <p>
                Die ODR und die Netze ODR sind treibende Kräfte der Energiewende
                – und das bleiben wir. Die Mitarbeiterinnen und Mitarbeiter sind
                stark mit dem Unternehmen verbunden und verfügen über ein hohes
                Maß an Kompetenz, um die Energiewende erfolgreich
                mitzugestalten. Unser großer Dank gilt allen Mitarbeiterinnen
                und Mitarbeitern für ihren Einsatz im vergangenen Jahr, die
                insbesondere in diesen turbulenten Zeiten Unglaubliches
                geleistet und sich mit Kraft und Willen für die Ziele der ODR
                und Netze ODR eingesetzt haben. Ein weiteres Dankeschön möchten
                wir unseren Kundinnen und Kunden sowie Partnerinnen und Partnern
                für das besondere Vertrauen und die sehr gute Zusammenarbeit
                aussprechen.
              </p>
              <p><br />Danke!<br /></p>
              <p><br />Mit freundlichen Grüßen<br /></p>
            </div>
            <div class="content-wrapper">
              <h4 class="cursive">
                Frank Reitmajer <span class="separate"></span>Sebastian Maier
              </h4>
            </div>
          </div>
        </div>
      </div>
    </section>
    <div class="main-nav-section">
      <div class="container">
        <router-link to="/" tag="div"
          ><a class="link link__back"></a
        ></router-link>
        <router-link to="/anspruch" tag="div"
          ><a class="link link__next"></a
        ></router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

export default {
  name: "Aktionaersbrief",
  components: {},

  mounted: function () {
    window.scrollTo(0, 0);
    this.scrollAnimation();
  },
  methods: {
    scrollAnimation() {
      const contentBlocs = gsap.utils.toArray(".content-wrapper");
      contentBlocs.forEach((contentBloc) => {
        //const signature = contentBloc.querySelector('h4.cursive');
        gsap.from(contentBloc, {
          y: 50,
          delay: 1.5,
          opacity: 0,
          duration: 1,
          scrollTrigger: {
            trigger: contentBloc,
            toggleActions: "play pause resume reset",
            //start: "bottom bottom",
            //end: "center center",
          },
        });
      });

      const signature = document.querySelector("h4.cursive");
      gsap.from(signature, {
        opacity: 0,
        duration: 2,
        scrollTrigger: {
          trigger: signature,
          toggleActions: "play pause resume reset",
        },
      });

      gsap.to("progress", {
        value: 100,
        ease: "none",
        scrollTrigger: { scrub: 0.15 },
      });

      const imgContent = document.querySelector(".content-image");
      gsap.from(imgContent, {
        scale: 0.4,
        opacity: 0,
        duration: 1.5,
        scrollTrigger: {
          trigger: imgContent,
          toggleActions: "play pause resume reset",
          start: "bottom bottom",
          end: "top top",
        },
      });
    },
  },
};
</script>

<style lang="scss">
@import "./../scss/views/aktionaersbrief.scss";
</style>
